import { render } from "./building-block-preview.vue?vue&type=template&id=7cae5aa6&lang=pug"
import script from "./building-block-preview.vue?vue&type=script&lang=js"
export * from "./building-block-preview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__